import React, { PureComponent, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';

import ReactQuill, { Quill } from 'react-quill';
import ImageResize from 'quill-image-resize';
import StoreLeftMenu from '../../menu/StoreLeftMenu';
import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
import ItemPreview from './ItemPreview';
// import { Modal } from "react-responsive-modal";

Quill.register('modules/ImageResize', ImageResize);

class StoreEdit extends PureComponent {
  state = {
    point: '',
    categoryID: 303,
    title: '',
    content: '',
    active: false,
    showRaw: false,
    preview: false,
  };
  _isLoad = false;
  modules = {
    toolbar: {
      container: '#toolbar',
      /*
            container: [
                //[{ 'font': [] }],
                [{ 'header': [1, 2, false] }],
                ['bold', 'italic', 'underline','strike', 'blockquote'],
                [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
                ['link', 'image'],
                [{ 'align': [] }, { 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                ['clean']
            ],
            */
      handlers: {
        image: () => this._imageHandler(),
        undo: () => this.undoChange(),
        redo: () => this.redoChange(),
      },
    },
    ImageResize: {
      parchment: Quill.import('parchment'),
    },
  };

  formats = [
    //'font',
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image',
    'align',
    'color',
    'background',
  ];
  componentDidMount = () => {
    this._isLoad = true;
    const { loginId, history } = this.props;

    if (
      loginId === 'admin' ||
      loginId === 'dlrhrjs33' ||
      loginId === 'lsy7414' ||
      loginId === 'dooyu63' ||
      loginId === 'xwuuwx' ||
      loginId === 'aji311' ||
      loginId === 'animi15' ||
      loginId === 'yoonyg00'
    ) {
      const idx = this.props.childProps.idx;
      this._getData(idx);
    } else {
      alert('글쓰기가 허락된 계정이 아닙니다.');
      history.goBack();
    }
  };
  componentWillUnmount = () => {
    this._isLoad = false;
  };
  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    return this.props.childProps.idx !== nextProps.childProps.idx;
  };
  componentWillReceiveProps = (nextProps) => {
    if (this.props.childProps.idx !== nextProps.childProps.idx) {
      this.getData(nextProps.childProps.idx);
    }
  };

  _getData = async (idx) => {
    const result = await this._getDataApi(idx);
    const intReturn = result.data[0].intReturn;
    const editData = result.data[0].listData;

    if (intReturn === 0) {
      if (this._isLoad) {
        this.setState({
          editData,
          categoryID: editData[0].categoryID,
          title: editData[0].title,
          content: editData[0].content,
          point: editData[0].id,
          active: editData[0].active,
          idx,
        });
      }
    }
  };
  _getDataApi = (idx) => {
    const { apiUrl } = this.props;

    return axios
      .post(apiUrl + '/storyEdit', {
        params: {
          idx: idx,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert("오류가 발생했습니다.");
      });
  };

  undoChange = () => {
    this.quillRef.history.undo();
  };
  redoChange = () => {
    this.quillRef.history.redo();
  };

  _imageHandler = () => {
    //console.log('img handler...')
    const input = document.createElement('input');
    // 속성 써주기
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/*');
    input.click();

    input.addEventListener('change', async () => {
      //console.log('온체인지');
      const file = input.files[0];
      // multer에 맞는 형식으로 데이터 만들어준다.
      const formData = new FormData();
      formData.append('upload', file); // formData는 키-밸류 구조
      // 백엔드 multer라우터에 이미지를 보낸다.
      try {
        const result = await axios.post(
          'https://ticket.aniplustv.com:3100/uploadBoard',
          formData
        );
        //console.log(result)
        //console.log('성공 시, 백엔드가 보내주는 데이터', result.data.url);

        const IMG_URL = result.data.url;
        // 이 URL을 img 태그의 src에 넣은 요소를 현재 에디터의 커서에 넣어주면 에디터 내에서 이미지가 나타난다
        // src가 base64가 아닌 짧은 URL이기 때문에 데이터베이스에 에디터의 전체 글 내용을 저장할 수있게된다
        // 이미지는 꼭 로컬 백엔드 uploads 폴더가 아닌 다른 곳에 저장해 URL로 사용하면된다.
        //console.log(this.quillRef)
        // 이미지 태그를 에디터에 써주기 - 여러 방법이 있다.
        const editor = this.quillRef.getEditor(); // 에디터 객체 가져오기
        // 1. 에디터 root의 innerHTML을 수정해주기
        // editor의 root는 에디터 컨텐츠들이 담겨있다. 거기에 img태그를 추가해준다.
        // 이미지를 업로드하면 -> 멀터에서 이미지 경로 URL을 받아와 -> 이미지 요소로 만들어 에디터 안에 넣어준다.
        // editor.root.innerHTML =
        //   editor.root.innerHTML + `<img src=${IMG_URL} /><br/>`; // 현재 있는 내용들 뒤에 써줘야한다.

        // 2. 현재 에디터 커서 위치값을 가져온다
        const range = editor.getSelection();
        // 가져온 위치에 이미지를 삽입한다
        setTimeout(() => {
          editor.insertEmbed(range.index, 'image', IMG_URL);
        }, 500);
      } catch (error) {
        //console.log(error)
        alert('이미지를 업로드중 오류가 발생했습니다. 다시 시도해 주세요');
      }
    });
  };
  _pointChange = (e) => {
    if (this._isLoad) {
      this.setState({
        point: e.target.value,
      });
    }
  };
  _onTitleChange = (e) => {
    if (this._isLoad) {
      this.setState({
        title: e.target.value,
      });
    }
  };
  _onContentChange = (value) => {
    //console.log(value)
    if (this._isLoad) {
      this.setState({
        content: value,
      });
    }
  };
  _categoryChange = (e) => {
    if (this._isLoad) {
      this.setState({
        categoryID: e.target.value,
      });
    }
  };
  _activeChange = (e) => {
    if (this._isLoad) {
      this.setState({
        active: e.target.value,
      });
    }
  };
  _handleChangeRaw(e) {
    if (this._isLoad) {
      this.setState({ rawHtml: e.target.value });
    }
  }
  _onWrite = async () => {
    const { loginId } = this.props;
    // const board_id = 301;
    const { point, title, content, active } = this.state;
    const { editSuccess } = this.props.childProps;
    let imgUrl;
    var strReg = new RegExp('http(s)?://*[^>]*\\.(jpg|gif|png)', 'gim');
    var xArr = content.match(strReg);
    if (
      loginId !== 'admin' &&
      loginId !== 'dlrhrjs33' &&
      loginId !== 'lsy7414' &&
      loginId !== 'dooyu63' &&
      loginId !== 'xwuuwx' &&
      loginId !== 'aji311' &&
      loginId !== 'animi15' &&
      loginId !== 'yoonyg00'
    ) {
      return false;
    }

    if (loginId === null || loginId === undefined || loginId === '') {
      toast.error('로그인후 이용이 가능합니다.');
      return false;
    }
    if (title === null || title === undefined || loginId === '') {
      toast.error('제목을 입력해 주세요.');
      return false;
    }
    if (content === null || content === undefined || content === '') {
      toast.error('내용을 입력해 주세요.');
      return false;
    }
    if (point === null || point === undefined || point === '') {
      toast.error('지점을 선택해 주세요.');
      return false;
    }
    if (active === null || active === undefined || active === '') {
      toast.error('활성여부를 선택해 주세요.');
      return false;
    }
    if (xArr === '' || xArr === undefined || xArr === null) {
      //m = ''
      imgUrl = '';
    } else {
      if (xArr.length > 0) {
        //m =  rex.exec(imgs)
        //console.log(m)
        imgUrl = xArr[0];
      } else {
        //m = ''
        imgUrl = '';
      }
    }

    //console.log(point)
    //console.log(title)
    //console.log(imgUrl)
    //console.log(content)
    //console.log(categoryID)
    // console.log(active)

    const result = await this._onWriteApi(imgUrl);
    const intReturn = result.data[0].intReturn;

    if (intReturn === 0) {
      //alert('성공적으로 등록되었습니다.')
      if (this._isLoad) {
        toast.success('성공적으로 등록되었습니다.');
        this.setState({
          point: '',
          categoryID: 0,
          title: '',
          content: '',
          active: false,
          showRaw: false,
        });
        editSuccess();
      }
    } else {
      //alert('등록중 오류가 발생했습니다.')
      toast.error('등록중 오류가 발생했습니다.');
    }
  };
  _onWriteApi = (imgUrl) => {
    const { apiUrl } = this.props;
    const { title, content, categoryID, active, idx } = this.state;
    // const board_id = 301;
    return axios
      .post(apiUrl + '/adminBoardEdit', {
        params: {
          idx: parseInt(idx),
          //board_id: board_id,
          //userid: point,
          categoryID: categoryID,
          imgUrl: imgUrl,
          title: title,
          content: content,
          active: active,
        },
      })
      .then((response) => response)
      .catch((error) => {
        // alert('오류가 발생했습니다.');
      });
  };
  handleChangeRaw = (e) => {
    if (this._isLoad) {
      this.setState({
        rawHtml: e.target.value,
      });
    }
  };
  handleClickShowRaw = () => {
    const { showRaw } = this.state;
    if (this._isLoad) {
      this.setState({
        showRaw: !showRaw,
      });
      this.syncViews(showRaw);
    }
  };
  syncViews = (showRaw) => {
    if (this._isLoad) {
      if (showRaw) {
        this.setState({ content: this.state.rawHtml });
      } else {
        this.setState({ rawHtml: this.state.content });
      }
    }
  };
  _preview = () => {
    // const { preview, content } = this.state;
    //console.log(content)
    if (this._isLoad) {
      this.setState({
        preview: true,
      });
    }
  };
  _previewClose = () => {
    if (this._isLoad) {
      this.setState({
        preview: false,
      });
    }
  };
  _onCloseModal = () => {
    if (this._isLoad) {
      this.setState({
        preview: false,
      });
    }
  };
  _cancel = () => {
    const { editCancel } = this.props.childProps;
    editCancel();
  };
  render() {
    const { loginId } = this.props;
    const {
      point,
      title,
      content,
      categoryID,
      active,
      rawHtml,
      showRaw,
      preview,
    } = this.state;
    return (
      <Fragment>
        <div className="content" style={{ display: preview ? 'none' : '' }}>
          {/*좌측메뉴*/}
          <StoreLeftMenu />

          <div className="vod_list_right store_right">
            <div className="store_wrap">
              <div className="store_blog">
                <div className="blog_top" style={{ marginTop: 10 }}>
                  <h2 className="tit">매장 이야기 글수정</h2>
                </div>
                <div
                  style={{
                    height: '650px',
                    paddingTop: 80,
                    backgroundColor: '#fff',
                    padding: 50,
                  }}
                >
                  {/*
                                    <div>
                                        <span onClick={this.handleClickShowRaw}>html</span>
                                    </div>
                                    */}
                  <div style={{ paddingBottom: 10 }}>
                    <input
                      type="text"
                      value={title}
                      name="title"
                      onChange={this._onTitleChange}
                      style={{ width: '100%', height: 30 }}
                      placeholder="제목을 입력해주세요"
                    />
                  </div>
                  <div>
                    <CustomToolbar onClickRaw={this.handleClickShowRaw} />
                    <ReactQuill
                      style={{
                        height: 390,
                        display: showRaw ? 'none' : 'block',
                      }}
                      theme="snow"
                      modules={this.modules}
                      formats={this.formats}
                      ref={(ref) => (this.quillRef = ref)}
                      placeholder={'내용을 입력해주세요'}
                      value={content || ''}
                      onChange={(content, delta, source, editor) =>
                        this._onContentChange(editor.getHTML())
                      }
                    />
                    <textarea
                      style={{
                        display: showRaw ? 'block' : 'none',
                        width: '100%',
                        height: 300,
                      }}
                      onChange={this.handleChangeRaw}
                      value={rawHtml}
                    />
                  </div>

                  <div style={{ marginTop: 10 }}>
                    <select
                      name="point"
                      onChange={this._pointChange}
                      value={point}
                      className="store_select"
                    >
                      {loginId === 'dlrhrjs33' ? (
                        <option value="hapjung">합정점</option>
                      ) : loginId === 'lsy7414' || loginId === 'dooyu63' ? (
                        <option value="daejeon">대전점</option>
                      ) : loginId === 'xwuuwx' ? (
                        <option value="gwangju">광주점</option>
                      ) : loginId === 'aji311' ? (
                        <option value="aji311">부산점</option>
                      ) : loginId === 'admin' ? (
                        <>
                          <option value="">지점 선택</option>
                          <option value="hapjung">합정점</option>
                          <option value="daejeon">대전점</option>
                          <option value="gwangju">광주점</option>
                          <option value="busan">부산점</option>
                        </>
                      ) : null}
                    </select>
                  </div>
                  {/*
                                    <div>
                                        <span>분류: </span>
                                        <select name="categoryID" onChange={this._categoryChange} value={categoryID}>
                                            <option value={0}>선택</option>
                                            <option value={301}>공지사항</option>
                                            <option value={302}>이벤트</option>
                                            <option value={303}>매장이야기</option>
                                        </select>
                                    </div>
                                    */}
                  <div style={{ marginTop: 10 }}>
                    <select
                      name="active"
                      onChange={this._activeChange}
                      value={active}
                      className="store_select"
                    >
                      <option value="">선택</option>
                      <option value={true}>활성</option>
                      <option value={false}>비활성</option>
                    </select>
                  </div>
                  <div style={{ marginTop: 10 }}>
                    <button
                      onClick={this._onWrite}
                      style={{
                        color: '#fff',
                        cursor: 'pointer',
                        width: '100%',
                        height: 40,
                        textAlign: 'center',
                        backgroundColor: '#ff5d24',
                        borderRadius: 5,
                      }}
                    >
                      수정
                    </button>
                  </div>
                  <div style={{ marginTop: 10 }}>
                    <button
                      onClick={this._preview}
                      style={{
                        color: '#fff',
                        cursor: 'pointer',
                        width: '100%',
                        height: 40,
                        textAlign: 'center',
                        backgroundColor: 'gray',
                        borderRadius: 5,
                      }}
                    >
                      미리보기
                    </button>
                  </div>
                  <div style={{ marginTop: 10 }}>
                    <button
                      onClick={this._cancel}
                      style={{
                        color: '#fff',
                        cursor: 'pointer',
                        width: '100%',
                        height: 40,
                        textAlign: 'center',
                        backgroundColor: 'black',
                        borderRadius: 5,
                      }}
                    >
                      취소
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            display: preview ? '' : 'none',
            position: 'absolute',
            left: 0,
            top: 0,
            width: '100%',
          }}
        >
          <ItemPreview
            content={content}
            title={title}
            point={point}
            categoryID={categoryID}
            previewClose={this._previewClose}
          />
        </div>
      </Fragment>
    );
  }
}

const CustomToolbar = ({ onClickRaw }) => (
  <div id="toolbar">
    <span className="ql-formats">
      {/*
        <select className="ql-font" defaultValue="arial">
          <option value="arial">Arial</option>
          <option value="comic-sans">Comic Sans</option>
          <option value="courier-new">Courier New</option>
          <option value="georgia">Georgia</option>
          <option value="helvetica">Helvetica</option>
          <option value="lucida">Lucida</option>
          <option value="돋움">돋움</option>
          <option value="굴림">굴림</option>
        </select>
        
        <select className="ql-size" defaultValue="medium">
          <option value="extra-small">Size 1</option>
          <option value="small">Size 2</option>
          <option value="medium">Size 3</option>
          <option value="large">Size 4</option>
        </select>
        */}
      <select className="ql-header" defaultValue="3">
        <option value="1">Heading</option>
        <option value="2">Subheading</option>
        <option value="3">Normal</option>
      </select>
    </span>
    <span className="ql-formats">
      <button className="ql-bold" />
      <button className="ql-italic" />
      <button className="ql-underline" />
      <button className="ql-strike" />
    </span>
    <span className="ql-formats">
      <button className="ql-list" value="ordered" />
      <button className="ql-list" value="bullet" />
      <button className="ql-indent" value="-1" />
      <button className="ql-indent" value="+1" />
    </span>
    <span className="ql-formats">
      <button className="ql-script" value="super" />
      <button className="ql-script" value="sub" />
      <button className="ql-blockquote" />
      <button className="ql-direction" />
    </span>
    <span className="ql-formats">
      <select className="ql-align" />
      <select className="ql-color" />
      <select className="ql-background" />
    </span>
    <span className="ql-formats">
      <button className="ql-link" />
      <button className="ql-image" />
      <button className="ql-video" />
    </span>
    <span className="ql-formats">
      <button className="ql-formula" />
      <button className="ql-code-block" />
      <button className="ql-clean" />
    </span>
    <span className="ql-formats">
      <button
        style={{ fontSize: 7, fontWeight: 900, width: 50 }}
        onClick={onClickRaw}
      >
        {'</>'}
      </button>
    </span>

    {/*
      <span className="ql-formats">
        <button className="ql-undo">
          <CustomUndo />
        </button>
        <button className="ql-redo">
          <CustomRedo />
        </button>
      </span>
      */}
  </div>
);
/*
  const CustomUndo = () => (
    <svg viewBox="0 0 18 18">
      <polygon className="ql-fill ql-stroke" points="6 10 4 12 2 10 6 10" />
      <path
        className="ql-stroke"
        d="M8.09,13.91A4.6,4.6,0,0,0,9,14,5,5,0,1,0,4,9"
      />
    </svg>
  );
  
  // Redo button icon component for Quill editor
  const CustomRedo = () => (
    <svg viewBox="0 0 18 18">
      <polygon className="ql-fill ql-stroke" points="12 10 14 12 16 10 12 10" />
      <path
        className="ql-stroke"
        d="M9.91,13.91A4.6,4.6,0,0,1,9,14a5,5,0,1,1,5-5"
      />
    </svg>
  );
  */
export default shopContext(withRouter(React.memo(StoreEdit)));
